
import { Crosshair, Tooltip } from '@unovis/ts'
import { defineComponent } from 'vue'
import { XYRecord } from '~/utils/charts/unovis'
import { buildBarSeriesComponents } from './barSeries'
import ZChartBaseMixin from './zChartBaseMixin'

export default defineComponent({
  name: 'ZChartBar',
  mixins: [ZChartBaseMixin],
  props: {
    barOptions: {
      type: Object,
      default: () => ({
        barPadding: 0.5,
        stacked: 0
      })
    }
  },
  computed: {
    chartSignature(): string {
      return JSON.stringify({ ...this.baseSignatureData, barOptions: this.barOptions })
    }
  },
  methods: {
    buildChartComponents(x: (d: XYRecord) => number) {
      return buildBarSeriesComponents({
        chartType: 'bar',
        dataSets: this.dataSets,
        palette: this.palette,
        x,
        barOptions: this.barOptions as { barPadding?: number; stacked?: number | boolean }
      })
    },
    createCrosshair(tooltip?: Tooltip | null) {
      const dataIndices = this.dataSets.map((_, index) => index)
      const stacked = Boolean((this.barOptions as Record<string, unknown>)?.stacked)
      const yAccessors = dataIndices.map((index) => (d: XYRecord) => d.values[index] ?? null)
      const yStackedAccessors = stacked
        ? dataIndices.map((index) => (d: XYRecord) => d.values[index] ?? null)
        : undefined
      const crosshairColors = dataIndices.map((index) => this.palette[index] || this.palette[0])

      return new Crosshair<XYRecord>({
        x: (d: XYRecord) => d.x,
        ...(stacked ? { yStacked: yStackedAccessors } : { y: yAccessors }),
        snapToData: true,
        hideWhenFarFromPointer: false,
        color: crosshairColors,
        strokeColor: crosshairColors,
        strokeWidth: 2,
        tooltip: tooltip ?? undefined,
        template: (datum: XYRecord) => this.createCrosshairTemplate(datum)
      })
    }
  }
})
